const months = 'Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec'.split(' ')

export const startAndEndDate = (start, end, timezone) => {
  if (!start || !end) return null
  if (!timezone) timezone = 'UTC'

  // console.log('startAndEndDate', start, end, timezone)

  const startDate = new Date(start)
  const startDay = startDate.toLocaleString('en-GB', {
    day: '2-digit',
    timeZone: timezone,
  })
  const startMonth = startDate.toLocaleString('en-GB', {
    month: '2-digit',
    timeZone: timezone,
  })
  const endDate = new Date(end)
  const endDay = endDate.toLocaleString('en-GB', {
    day: '2-digit',
    timeZone: timezone,
  })
  const endMonth = endDate.toLocaleString('en-GB', {
    month: '2-digit',
    timeZone: timezone,
  })
  const endYear = endDate.toLocaleString('en-GB', {
    year: '2-digit',
    timeZone: timezone,
  })

  // const startDate = start.split('-')
  // const endDate = end.split('-')

  // get start day
  // const startDay = parseInt(startDate[2])
  // const startMonth = parseInt(startDate[1])

  // // get end day
  // const endDay = parseInt(endDate[2])
  // const endMonth = parseInt(endDate[1])
  // const endYear = endDate[0]

  const sameDay = startDay === endDay
  const sameMonth = startMonth === endMonth

  let formattedString = startDay + ' '
  if (!sameMonth) formattedString += months[startMonth - 1] + ' '
  if (!sameDay) formattedString += '- ' + endDay + ' '
  formattedString += months[endMonth - 1] + ' ' + endYear

  return formattedString
}

export const startAndEndTime = (start, end, timezone) => {
  if (!start || !end) return null

  // get start day
  const startTime = getStartTime(start, timezone)
  const endTime = getEndTime(end, timezone)

  return startTime + ' - ' + endTime
}

const getStartTime = (start, timezone) => {
  if (!start) return null
  const startDate = new Date(start)
  const startTime = startDate.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: timezone,
  })
  return startTime
}
const getEndTime = (end, timezone) => {
  if (!end) return null
  const endDate = new Date(end)
  const endTime = endDate.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: timezone,
  })
  return endTime
}
export const getStartDate = (start, timezone) => {
  if (!start) return null
  const startDate = new Date(start)
  const startDay = startDate.toLocaleDateString('en-GB', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    timeZone: timezone,
  })
  return startDay
}
export const getStartDateTime = (start, timezone) => {
  const startDate = getStartDate(start, timezone)
  const startTime = getStartTime(start, timezone)
  return startDate + ' ' + startTime
}

export const getTimeFormat = (timestamp) => {
  const relativeTime = new Intl.RelativeTimeFormat('en', { numeric: 'auto', style: 'narrow' })
  // if less than 42hours ago then show time
  const oneDay = 1000 * 60 * 60 * 24
  const oneWeek = oneDay * 7
  const oneYear = oneDay * 365
  const diff = Date.now() - timestamp
  if (diff < oneDay)
    return new Date(timestamp).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })
  if (diff < oneWeek) return relativeTime.format(Math.round(-diff / oneDay), 'day')
  if (diff < oneYear) return new Date(timestamp).toLocaleString('en-GB', { day: 'numeric', month: 'long' })
  else return new Date(timestamp).toLocaleString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
}

export const daysBetweenDates = (day1, day2) => {
  const date1 = new Date(day1)
  const date2 = new Date(day2)
  const timeDiff = Math.abs(date2.getTime() - date1.getTime())
  const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))
  return diffDays
}

export function articleDate(dateString) {
  return new Date(`${dateString}`).toLocaleDateString('en-US', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
  })
}

export const getConferenceDay = (start, timezone, offset) => {
  if (!start) return null
  const startDate = new Date(start)
  //offset the date by the number of offset days
  startDate.setDate(startDate.getDate() + offset)
  const startDay = startDate.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    timeZone: timezone,
  })
  return startDay
}
